import { RecentEdits } from '@/ui/RecentEdits'
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/ui/shadcn/dialog'

interface RecentEditsDialogProps {
  mobile: boolean
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function RecentEditsDialog({ mobile, open, onOpenChange }: RecentEditsDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className={mobile
        ? 'bottom-0 left-0 top-auto max-h-[85dvh] w-full max-w-none translate-x-0 translate-y-0 overflow-y-auto rounded-b-none rounded-t-2xl'
        : 'max-h-[80dvh] max-w-4xl overflow-y-auto'}>
        <DialogHeader>
          <DialogTitle>Recent edits</DialogTitle>
        </DialogHeader>
        <RecentEdits onRestored={() => onOpenChange(false)} />
      </DialogContent>
    </Dialog>
  )
}
